import { render, staticRenderFns } from "./shopDriverDetail.vue?vue&type=template&id=73b358a0&"
import script from "./shopDriverDetail.vue?vue&type=script&lang=js&"
export * from "./shopDriverDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports